import axios from 'axios';
import {
  FETCH_FRESHDESK_TICKETS,
  FETCH_FRESHDESK_CONVERSATIONS,
  FETCH_FRESHDESK_USER_ID,
  UPDATE_FRESHDESK_CONVERSATIONS,
  UPDATE_FRESHDESK_TICKET,
  REQUEST_RESULT, CREATE_FRESHDESK_TICKET,
} from './types';

const FRESHDESK_API_KEY = process.env.REACT_APP_FRESHDESK_API_KEY;
const FRESHDESK_DOMAIN = 'eskassa.freshdesk.com';

export const FRESHDESK_STATUSES = {
  OPEN: { code: 2, defaultMessage: 'Open', translationId: 'freshdesk.status.open' },
  PENDING: { code: 3, defaultMessage: 'Pending', translationId: 'freshdesk.status.pending' },
  RESOLVER: { code: 4, defaultMessage: 'Resolver', translationId: 'freshdesk.status.resolver' },
  CLOSED: { code: 5, defaultMessage: 'Closed', translationId: 'freshdesk.status.closed' },
};

const FRESHDESK_GROUP = 47000664567;

export const fetchContact = (email) => {
  return dispatch => {
    axios.get(`https://${FRESHDESK_DOMAIN}/api/v2/contacts?email=${email}`, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then((response) => {
      dispatch({
        type: FETCH_FRESHDESK_USER_ID,
        payload: response.data[0]?.id,
      });
    }).catch((error) => {
      const statusCode = error.response?.status || 'Unknown status';
      const errors = error.response?.data?.errors || [];
      const detailedErrorMsg = errors.find(error => error.field === 'email')
        ? `email address not found. Contact ES Kassasystem Customer Support to change your e-mail address.`
        : (error.response?.data?.message + `Status: ${statusCode}` || 'An unknown error occurred');
      const errorMsg = `Error: ${detailedErrorMsg}`;
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: errorMsg },
      });
    });
  };
};

export const fetchGroups = () => {
  return axios.get(`https://${FRESHDESK_DOMAIN}/api/v2/groups`, {
    auth: {
      username: FRESHDESK_API_KEY,
      password: 'X',
    },
  }).then((response) => {
    console.log(response);
  }).catch((error) => {
    console.log(error);
  });
};

export const fetchGroupByID = (ID) => {
  return axios.get(`https://${FRESHDESK_DOMAIN}/api/v2/groups/${ID}`, {
    auth: {
      username: FRESHDESK_API_KEY,
      password: 'X',
    },
  }).then((response) => {
    console.log(response);
  }).catch((error) => {
    console.log(error);
  });
};

export function fetchTickets(email, setLoading) {
  return dispatch => {
    axios.get(`https://${FRESHDESK_DOMAIN}/api/v2/tickets?email=${encodeURIComponent(email)}&include=description`, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then(response => {
      dispatch({
        type: FETCH_FRESHDESK_TICKETS,
        payload: response.data,
      });
    }).catch((error) => {
      const statusCode = error.response?.status || 'Unknown status';
      const detailedErrorMsg = error.response?.data?.errors?.[0]?.message ||
        error.response?.data?.message ||
        'An unknown error occurred';
      const errorMsg = `Error: ${detailedErrorMsg}. Status: ${statusCode}`;
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: errorMsg },
      });
    }).finally(() => {
      setLoading && setLoading(false);
    });
  };
}

export function fetchConversationById(id) {
  return dispatch => {
    axios.get(`https://${FRESHDESK_DOMAIN}/api/v2/tickets/${id}/conversations`, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then((response) => {
      dispatch({
        type: FETCH_FRESHDESK_CONVERSATIONS,
        payload: { ticketId: id, data: response.data },
      });
    }).catch((error) => {
      let errorMsg = 'Error: fetching conversations';
      if (error.response) {
        errorMsg += `: ${error.response.status} ${error.response.data.message || ''}`;
      }
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: errorMsg },
      });
    });
  };
}

export const updateTicket = (ticketId, content) => {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets/${ticketId}`;
  
  return (dispatch) => {
    return axios.put(url, { description: content }, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_FRESHDESK_TICKET,
        payload: [response.data],
      });
      return response.data;
    }).catch((error) => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: 'Error: post reply', error },
      });
      return Promise.reject(error);
    });
  };
};

export const postTicketPrivateNote = (ticketId, content, userID) => {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets/${ticketId}/reply`;
  
  return (dispatch) => {
    return axios.post(url, { body: content, user_id: userID, private: true }, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: 'Error: private note', error },
      });
      return Promise.reject(error);
    });
  };
};

export const postTicketReply = (ticketId, content, userID, setIsSnackbarOpen) => {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets/${ticketId}/reply`;
  
  return (dispatch) => {
    return axios.post(url, { body: content, user_id: userID }, {
      auth: {
        username: FRESHDESK_API_KEY,
        password: 'X',
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_FRESHDESK_CONVERSATIONS,
        payload: {
          ticketId: ticketId,
          comment: response.data,
        },
      });
      setIsSnackbarOpen && setIsSnackbarOpen(true);
    }).catch((error) => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: 'Error: post reply', error },
      });
    });
  };
};

export const createTicket = (subject, content, email, noteData) => {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets`;
  const auth = {
    username: FRESHDESK_API_KEY,
    password: 'X',
  };
  
  const ticketData = {
    subject: subject,
    description: content,
    email: email,
    priority: 1,
    status: 2,
    group_id: FRESHDESK_GROUP,
    tags: ['Kund via Dinkassa.se'],
  };
  
  return (dispatch) => {
    return axios.post(url, ticketData, { auth })
      .then(response => {
        dispatch({
          type: CREATE_FRESHDESK_TICKET,
          payload: response.data,
        });
        const ticketID = response.data.id;
        return dispatch(createPrivateNote(ticketID, noteData));
      })
      .catch(error => {
        dispatch({
          type: REQUEST_RESULT,
          payload: { message: 'Error: creating ticket', error },
        });
      });
  };
};

export const createPrivateNote = (ticketId, noteData) => {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets/${ticketId}/notes`;
  const auth = {
    username: FRESHDESK_API_KEY,
    password: 'X',
  };
  
  const description = {
    body: noteData,
  };
  
  return dispatch => {
    return axios.post(url, description, { auth, private: true })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        dispatch({
          type: REQUEST_RESULT,
          payload: { message: 'Error: private note', error },
        });
      });
  };
};

export function closeTicket(ticketId) {
  const url = `https://${FRESHDESK_DOMAIN}/api/v2/tickets/${ticketId}`;
  
  return dispatch => {
    return axios.put(url, { status: FRESHDESK_STATUSES.CLOSED.code },
      {
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X',
        },
      }).then((response) => {
      dispatch({
        type: UPDATE_FRESHDESK_TICKET,
        payload: [response.data],
      });
    }).catch((error) => {
      dispatch({
        type: REQUEST_RESULT,
        payload: { message: 'Error: close ticket', error },
      });
    });
  };
}